export default __webpack_public_path__ + "static/media/fasting_planing@3x.0762ec18.jpg";